const SessionStorage  = {
  setJson: (key: string, value: any) => {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  },

  getJson: (key: string) => {
    const item: any = window.sessionStorage.getItem(key)

    if(item) {
      return JSON.parse(item)
    }

    return {}
  },

  setItem: (key: string, value: string) => {
    window.sessionStorage.setItem(key, value)
  },

  getItem: (key: string) => {
    return window.sessionStorage.getItem(key)
  },

  clearAll: () => {
    window.sessionStorage.clear()
  },

  removeItem: (key: string) => {
    window.sessionStorage.removeItem(key)
  }
}

export default SessionStorage
